/**
 * Wave 319 · BUG FIX (timezone): SQLite `datetime('now')` retorna strings
 * tipo `'2026-04-28 02:00:00'` — UTC, mas SEM marcador de timezone. JS
 * parseia esse formato como local time (browser zone), o que faz toda
 * conversão pra "America/Sao_Paulo" depois ser uma noop falsa: "02:00 UTC"
 * vira "02:00 BRT" em vez do correto "23:00 BRT do dia anterior".
 *
 * Esse helper olha a string. Se tem `T...Z` ou `+HH:MM` (ISO completo),
 * confia. Senão, força o tratamento como UTC.
 *
 * Use SEMPRE que for converter um timestamp vindo do servidor pra Date.
 */
export function parseServerDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const s = String(value).trim();
  if (!s) return null;
  // ISO 8601 com T separator E (Z ou ±offset) → seguro, parser nativo.
  // ex: 2026-04-28T02:00:00Z, 2026-04-28T02:00:00.123Z, 2026-04-28T02:00:00-03:00
  if (/T.*(Z|[+-]\d{2}:?\d{2})$/.test(s)) {
    const d = new Date(s);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  // Formato SQLite `YYYY-MM-DD HH:MM:SS[.fff]` ou `YYYY-MM-DDTHH:MM:SS` sem
  // marcador → assumimos UTC (que é o que SQLite retorna em `datetime('now')`).
  // Trocamos espaço por T (caso tenha) e anexamos Z pra forçar UTC.
  const normalized = s.replace(' ', 'T');
  const withZ = normalized.endsWith('Z') ? normalized : `${normalized}Z`;
  const d = new Date(withZ);
  return Number.isNaN(d.getTime()) ? null : d;
}
